const MAP = {
  Eligible: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Verified: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Paid: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Submitted: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Available: "bg-sky-50 text-sky-700 border-sky-200",
  Ineligible: "bg-rose-50 text-rose-700 border-rose-200",
  Rejected: "bg-rose-50 text-rose-700 border-rose-200",
  "Not Available": "bg-rose-50 text-rose-700 border-rose-200",
  "Not Submitted": "bg-rose-50 text-rose-700 border-rose-200",
  "Error / Deficiency": "bg-amber-50 text-amber-800 border-amber-200",
  Error: "bg-amber-50 text-amber-800 border-amber-200",
  "Incorrect Details": "bg-amber-50 text-amber-800 border-amber-200",
  Pending: "bg-slate-100 text-slate-700 border-slate-200",
  "Under Process": "bg-indigo-50 text-indigo-700 border-indigo-200",
  "Correction Submitted": "bg-indigo-50 text-indigo-700 border-indigo-200",
  "Verification Pending": "bg-violet-50 text-violet-700 border-violet-200",
  Archived: "bg-slate-200 text-slate-600 border-slate-300",
};

export const StatusBadge = ({ value, testId }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium ${MAP[value] || "bg-slate-100 text-slate-600 border-slate-200"}`}
  >
    {value || "—"}
  </span>
);
